import PersonalInfoView from "@/app/shared/account-settings/personal-info";
import { metaObject } from "@/config/site.config";

export const metadata = {
    ...metaObject("Profile Settings"),
};

export default function ProfileSettingsFormPage() {
    return <PersonalInfoView />;
}
